package com.macrofocus.eflux.data

import org.molap.dataframe.rowmajor.RowMajorDataFrame
import kotlin.reflect.KClass

class ZonePowerFlowColumn(
    val name: String,
    override val type: KClass<*>,
    val value: (ZonePowerFlowRecord) -> Any?
) : RowMajorDataFrame.Column<ZonePowerFlowRecord, Any?> {
    override fun getValue(row: ZonePowerFlowRecord): Any? {
        return value(row)
    }

    override fun toString(): String {
        return "$name"
    }

    companion object {
        val i = ZonePowerFlowColumn("i", Int::class, { it.i })
        val zoname = ZonePowerFlowColumn("zoname", String::class, { it.zoname })

        val all = arrayOf(
            i, zoname
        )
    }
}